import React from 'react';

import styled from 'styled-components';

import { LightIcon } from 'apps/promo/components/common/fromAuth/LightIcon/LightIcon';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import { logInfo } from 'apps/promo/helpers/clientLogger';
import media from 'apps/promo/theme/media';

import PromoInputWrapper from '../PromoInputWrapper';

export const SearchIconWrap = styled.div`
    margin-right: 16px;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const focus = (e) => {
    if (e.currentTarget) {
        const input = e.currentTarget.firstElementChild;
        input.focus();
    } else {
        if (__isDev__) {
            logInfo('Focus method not support');
        }
    }
};

export const PromoInputSearch = (props) => {
    return (
        <PromoRow indent="32px" onClick={(e) => props.toggle(e, true)}>
            <PromoInputWrapper
                name="search"
                setFocus={focus}
                leftInputComponent={
                    <SearchIconWrap>
                        <LightIcon name="search" color="secondary" />
                    </SearchIconWrap>
                }
            >
                <input type="search" placeholder={props.placeholder} autoFocus={props.autoFocus} />
            </PromoInputWrapper>
        </PromoRow>
    );
};
